import React from 'react';

import styles from './SectionGroup.scss';

const SectionGroup = ({ additionalClasses, children, type, refKey }) => (
  <div
    className={`SectionGroup${additionalClasses || ''}${
      type ? ` SectionGroup--${type}` : ''
    }`}
  >
    <div className="SectionGroup__container" ref={refKey}>
      {children}
    </div>
  </div>
);

export default SectionGroup;
